import React, { useEffect } from 'react'
import { UserRightsTable } from './UserRightsTable'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../components'
import { RequestLocationRights } from './RequestLocationRights'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../components'
import { getRights } from '../../state/rights'
import {RootState} from "../../state/reducer";

export const UserRightsDisplay = () => {
  const dispatch = useDispatch()
  const { user } = useSelector((state:RootState) => state.auth)
  const { rights } = useSelector((state:RootState) => state.userRights)
  useEffect(() => {
  !rights && dispatch(getRights(user))
  }, [dispatch, rights, user])
  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs="6"> My Rights</ReactBootstrap.Col>
          <ReactBootstrap.Col xs="6">
            <div className="text-end">
              <components.Slider
                size="sm"
                title={components.ICONS.PLUS}
                header="Request New Rights"
              >
                <RequestLocationRights user={user} />
              </components.Slider>
            </div>
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body className={'p-0'}>
        {!rights && <Loading />}
        {rights && <UserRightsTable rights={rights} />}
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
